export default class EDClassList {

    add(pClass) {

        if(!pClass) {
            return
        }

        if(Array.isArray(pClass)) {

            pClass.forEach(className => {
                this.addSingle(className)
            })

            return
        }

        this.addSingle(pClass)
    }

    addSingle(pClass) {

        this._classList.push(pClass)

        if(this._parent._DOMElement) {
            this._parent._DOMElement.classList.add(pClass)
        }
    }

    has(pClass) {
        return (this._classList.indexOf(pClass) > -1)
    }

    remove(pClass) {

        const index = this._classList.indexOf(pClass)

        if(index > -1) {
            this._classList.splice(index, 1)
        }

        if(this._parent._DOMElement) {
            this._parent._DOMElement.classList.remove(pClass)
        }
    }

    clear() {

        this._classList = new Array()

        if(this._parent._DOMElement) {
            this.clearDom()
        }
    }

    clearDom() {

        var classList = this._parent._DOMElement.classList

        while (classList.length > 0) {
            classList.remove(classList.item(0))
        }
    }

    sync() {
        if(this._parent._DOMElement) {
            this.clearDom()
            this.remder()
        }
    }

    render() {

        this._classList.forEach(elClass=>{
            this._parent._DOMElement.classList.add(elClass)
        })
    }

    constructor(pParent, pClass) {

        this._parent = pParent
        this._classList = new Array()

        if(pClass) {
            
            pClass = Array.isArray(pClass) ? pClass : pClass.replace(/ /g,"").split(",")

            pClass.forEach(elClass=>{
                this.add(elClass)
            })
        }
    }

}